/**
 * Converts seconds to a human-readable time format (HH:MM:SS)
 * @param {number} seconds - Number of seconds to convert
 * @returns {string} Formatted time string
 */
export const secondsToHumanReadable = (seconds) => {
  if (!seconds && seconds !== 0) return "N/A";
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  
  if (minutes > 0 || hours > 0) {
    parts.push(`${minutes}m`);
  }
  
  parts.push(`${remainingSeconds}s`);

  return parts.join(" ");
};

/**
 * Converts milliseconds to a human-readable time format
 * @param {number} ms - Number of milliseconds to convert
 * @returns {string} Formatted time string
 */
export const msToHumanReadable = (ms) => {
  return secondsToHumanReadable(Math.floor(ms / 1000));
};